import { Component, input, output } from '@angular/core';
import { ButtonComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';

export type ReviewDetailCardLayout = 'address' | 'details';

/**
 * Shared Review & Pay summary card chrome (title + Edit link + projected body).
 * Edit emits the target href so the page can confirm before navigating.
 */
@Component({
  selector: 'app-review-detail-card',
  imports: [ButtonComponent, TranslatePipe, TypographyComponent],
  templateUrl: './review-detail-card.html',
  styleUrl: './review-detail-card.scss',
})
export class ReviewDetailCard {
  readonly title = input.required<string>();
  readonly editHref = input.required<string>();
  readonly testId = input('');
  readonly cardLayout = input<ReviewDetailCardLayout>('details');
  /** When false, hides Edit (e.g. Get Labels post-payment confirmation). */
  readonly showEdit = input(true);
  readonly editRequested = output<string>();

  /**
   * Asks the page to confirm before leaving Review & Pay for the target step.
   */
  protected onEdit(): void {
    this.editRequested.emit(this.editHref());
  }
}
